const demoTimestamp = (dateString) => ({
  seconds: Math.floor(new Date(dateString).getTime() / 1000),
});

const createDeskMap = (count, columns = 4, startX = 40, startY = 40) => {
  const desks = {};
  for (let index = 0; index < count; index += 1) {
    const column = index % columns;
    const row = Math.floor(index / columns);
    desks[`desk${index + 1}`] = {
      rotation: 0,
      x: startX + column * 140,
      y: startY + row * 110,
    };
  }
  return desks;
};

export const GUEST_CLASSES = [
  {
    id: "class-1",
    name: "Year 9 English - Period 3",
    teacherId: "guest-demo-user",
    scheduleWeekA: "Tue P3",
    scheduleWeekB: "Tue P3",
    archived: false,
    demoVisible: true,
  },
  {
    id: "class-2",
    name: "Year 10 History - Period 5",
    teacherId: "guest-demo-user",
    scheduleWeekA: "Thu P5",
    scheduleWeekB: "Thu P5",
    archived: false,
    demoVisible: true,
  },
];

export const GUEST_STUDENTS = {
  "class-1": [
    { id: "student-1", name: "Alice Johnson", teacherId: "guest-demo-user", yearGroup: "Year 9", tutorGroup: "9A", pupilPremiumStatus: "Pupil Premium", senStatus: "None", senDetail: "", archived: false },
    { id: "student-2", name: "Benjamin Smith", teacherId: "guest-demo-user", yearGroup: "Year 9", tutorGroup: "9A", pupilPremiumStatus: "No", senStatus: "None", senDetail: "", archived: false },
    { id: "student-3", name: "Charlotte Williams", teacherId: "guest-demo-user", yearGroup: "Year 9", tutorGroup: "9B", pupilPremiumStatus: "Pupil Premium", senStatus: "SEN Support", senDetail: "ADHD", archived: false },
    { id: "student-4", name: "David Brown", teacherId: "guest-demo-user", yearGroup: "Year 9", tutorGroup: "9A", pupilPremiumStatus: "No", senStatus: "None", senDetail: "", archived: false },
    { id: "student-5", name: "Emma Davis", teacherId: "guest-demo-user", yearGroup: "Year 9", tutorGroup: "9B", pupilPremiumStatus: "No", senStatus: "None", senDetail: "", archived: false },
    { id: "student-6", name: "Freya Martinez", teacherId: "guest-demo-user", yearGroup: "Year 9", tutorGroup: "9C", pupilPremiumStatus: "Pupil Premium", senStatus: "SEN Support", senDetail: "Dyslexia", archived: false },
    { id: "student-7", name: "George Robinson", teacherId: "guest-demo-user", yearGroup: "Year 9", tutorGroup: "9A", pupilPremiumStatus: "No", senStatus: "None", senDetail: "", archived: false },
    { id: "student-8", name: "Hannah Taylor", teacherId: "guest-demo-user", yearGroup: "Year 9", tutorGroup: "9C", pupilPremiumStatus: "No", senStatus: "None", senDetail: "", archived: false },
    { id: "student-9", name: "Isaac Patel", teacherId: "guest-demo-user", yearGroup: "Year 9", tutorGroup: "9B", pupilPremiumStatus: "No", senStatus: "None", senDetail: "", archived: false },
    { id: "student-10", name: "Jasmine Lee", teacherId: "guest-demo-user", yearGroup: "Year 9", tutorGroup: "9C", pupilPremiumStatus: "Pupil Premium", senStatus: "None", senDetail: "", archived: false },
  ],
  "class-2": [
    { id: "student-11", name: "Kevin Anderson", teacherId: "guest-demo-user", yearGroup: "Year 10", tutorGroup: "10A", pupilPremiumStatus: "No", senStatus: "None", senDetail: "", archived: false },
    { id: "student-12", name: "Olivia Thompson", teacherId: "guest-demo-user", yearGroup: "Year 10", tutorGroup: "10A", pupilPremiumStatus: "Pupil Premium", senStatus: "None", senDetail: "", archived: false },
    { id: "student-13", name: "Patrick Harris", teacherId: "guest-demo-user", yearGroup: "Year 10", tutorGroup: "10B", pupilPremiumStatus: "No", senStatus: "SEN EHCP", senDetail: "Autism", archived: false },
    { id: "student-14", name: "Quinn Murphy", teacherId: "guest-demo-user", yearGroup: "Year 10", tutorGroup: "10B", pupilPremiumStatus: "No", senStatus: "None", senDetail: "", archived: false },
    { id: "student-15", name: "Rachel Clark", teacherId: "guest-demo-user", yearGroup: "Year 10", tutorGroup: "10A", pupilPremiumStatus: "Pupil Premium", senStatus: "None", senDetail: "", archived: false },
    { id: "student-16", name: "Sofia Green", teacherId: "guest-demo-user", yearGroup: "Year 10", tutorGroup: "10C", pupilPremiumStatus: "No", senStatus: "None", senDetail: "", archived: false },
  ],
};

export const GUEST_OBJECTIVES = {
  "class-1": [
    { id: "obj-1", title: "Uses textual evidence", category: "Reading", archived: false },
    { id: "obj-2", title: "Explains writer's intent", category: "Analysis", archived: false },
    { id: "obj-3", title: "Contributes to discussion", category: "Oracy", archived: false },
  ],
  "class-2": [
    { id: "obj-4", title: "Uses historical evidence", category: "Knowledge", archived: false },
    { id: "obj-5", title: "Explains causation", category: "Analysis", archived: false },
    { id: "obj-6", title: "Writes structured paragraph", category: "Extended writing", archived: false },
  ],
};

export const GUEST_EVENTS = {
  "class-1": [
    { id: "evt-1", type: "positive", studentIds: ["student-1"], timestamp: demoTimestamp("2026-03-03T09:08:00Z"), points: 2 },
    { id: "evt-2", type: "objective", studentIds: ["student-1", "student-5"], objectiveId: "obj-1", timestamp: demoTimestamp("2026-03-03T09:20:00Z"), points: 1 },
    { id: "evt-3", type: "negative", studentIds: ["student-3"], timestamp: demoTimestamp("2026-03-03T09:28:00Z"), points: 1 },
    { id: "evt-4", type: "positive", studentIds: ["student-6"], timestamp: demoTimestamp("2026-03-05T09:10:00Z"), points: 1 },
    { id: "evt-5", type: "objective", studentIds: ["student-6", "student-8"], objectiveId: "obj-2", timestamp: demoTimestamp("2026-03-05T09:24:00Z"), points: 1 },
    { id: "evt-6", type: "negative", studentIds: ["student-2", "student-7"], timestamp: demoTimestamp("2026-03-05T09:31:00Z"), points: 1 },
    { id: "evt-7", type: "positive", studentIds: ["student-10"], timestamp: demoTimestamp("2026-03-10T09:12:00Z"), points: 2 },
    { id: "evt-8", type: "objective", studentIds: ["student-10", "student-9"], objectiveId: "obj-3", timestamp: demoTimestamp("2026-03-10T09:22:00Z"), points: 1 },
    { id: "evt-9", type: "positive", studentIds: ["student-4", "student-5"], timestamp: demoTimestamp("2026-03-12T09:18:00Z"), points: 1 },
    { id: "evt-10", type: "negative", studentIds: ["student-3"], timestamp: demoTimestamp("2026-03-12T09:34:00Z"), points: 2 },
    { id: "evt-11", type: "objective", studentIds: ["student-2", "student-4"], objectiveId: "obj-1", timestamp: demoTimestamp("2026-03-17T09:19:00Z"), points: 1 },
    { id: "evt-12", type: "positive", studentIds: ["student-8"], timestamp: demoTimestamp("2026-03-17T09:29:00Z"), points: 1 },
    { id: "evt-13", type: "negative", studentIds: ["student-7"], timestamp: demoTimestamp("2026-03-19T09:16:00Z"), points: 1 },
    { id: "evt-14", type: "objective", studentIds: ["student-1", "student-6"], objectiveId: "obj-2", timestamp: demoTimestamp("2026-03-19T09:23:00Z"), points: 1 },
    { id: "evt-15", type: "positive", studentIds: ["student-5"], timestamp: demoTimestamp("2026-03-24T09:11:00Z"), points: 2 },
    { id: "evt-16", type: "objective", studentIds: ["student-5", "student-10"], objectiveId: "obj-3", timestamp: demoTimestamp("2026-03-24T09:25:00Z"), points: 1 },
    { id: "evt-17", type: "negative", studentIds: ["student-2"], timestamp: demoTimestamp("2026-03-26T09:30:00Z"), points: 1 },
    { id: "evt-18", type: "positive", studentIds: ["student-9"], timestamp: demoTimestamp("2026-03-26T09:33:00Z"), points: 1 },
  ],
  "class-2": [
    { id: "evt-19", type: "positive", studentIds: ["student-11", "student-15"], timestamp: demoTimestamp("2026-03-04T13:12:00Z"), points: 1 },
    { id: "evt-20", type: "objective", studentIds: ["student-12"], objectiveId: "obj-4", timestamp: demoTimestamp("2026-03-04T13:24:00Z"), points: 1 },
    { id: "evt-21", type: "negative", studentIds: ["student-13"], timestamp: demoTimestamp("2026-03-04T13:37:00Z"), points: 1 },
    { id: "evt-22", type: "positive", studentIds: ["student-16"], timestamp: demoTimestamp("2026-03-11T13:10:00Z"), points: 2 },
    { id: "evt-23", type: "objective", studentIds: ["student-14", "student-16"], objectiveId: "obj-5", timestamp: demoTimestamp("2026-03-11T13:21:00Z"), points: 1 },
    { id: "evt-24", type: "negative", studentIds: ["student-11"], timestamp: demoTimestamp("2026-03-11T13:34:00Z"), points: 1 },
    { id: "evt-25", type: "positive", studentIds: ["student-12"], timestamp: demoTimestamp("2026-03-18T13:14:00Z"), points: 1 },
    { id: "evt-26", type: "objective", studentIds: ["student-12", "student-15"], objectiveId: "obj-6", timestamp: demoTimestamp("2026-03-18T13:27:00Z"), points: 1 },
    { id: "evt-27", type: "negative", studentIds: ["student-13", "student-14"], timestamp: demoTimestamp("2026-03-18T13:39:00Z"), points: 1 },
    { id: "evt-28", type: "positive", studentIds: ["student-15"], timestamp: demoTimestamp("2026-03-25T13:11:00Z"), points: 2 },
    { id: "evt-29", type: "objective", studentIds: ["student-11", "student-12"], objectiveId: "obj-4", timestamp: demoTimestamp("2026-03-25T13:25:00Z"), points: 1 },
    { id: "evt-30", type: "positive", studentIds: ["student-14"], timestamp: demoTimestamp("2026-03-25T13:31:00Z"), points: 1 },
  ],
};

export const GUEST_ATTENDANCE = {
  "class-1": [
    { id: "att-1", date: "2026-03-03", presentStudentIds: ["student-1", "student-2", "student-4", "student-5", "student-6", "student-7", "student-8", "student-9", "student-10"], absentStudentIds: ["student-3"], timestamp: demoTimestamp("2026-03-03T08:55:00Z") },
    { id: "att-2", date: "2026-03-05", presentStudentIds: ["student-1", "student-2", "student-3", "student-4", "student-5", "student-6", "student-8", "student-9", "student-10"], absentStudentIds: ["student-7"], timestamp: demoTimestamp("2026-03-05T08:55:00Z") },
    { id: "att-3", date: "2026-03-10", presentStudentIds: ["student-1", "student-3", "student-4", "student-5", "student-6", "student-7", "student-8", "student-9", "student-10"], absentStudentIds: ["student-2"], timestamp: demoTimestamp("2026-03-10T08:55:00Z") },
    { id: "att-4", date: "2026-03-12", presentStudentIds: ["student-1", "student-2", "student-3", "student-4", "student-5", "student-6", "student-7", "student-8", "student-10"], absentStudentIds: ["student-9"], timestamp: demoTimestamp("2026-03-12T08:55:00Z") },
    { id: "att-5", date: "2026-03-17", presentStudentIds: ["student-1", "student-2", "student-4", "student-5", "student-6", "student-7", "student-8", "student-9", "student-10"], absentStudentIds: ["student-3"], timestamp: demoTimestamp("2026-03-17T08:55:00Z") },
    { id: "att-6", date: "2026-03-19", presentStudentIds: ["student-1", "student-2", "student-3", "student-4", "student-5", "student-6", "student-8", "student-9", "student-10"], absentStudentIds: ["student-7"], timestamp: demoTimestamp("2026-03-19T08:55:00Z") },
    { id: "att-7", date: "2026-03-24", presentStudentIds: ["student-1", "student-2", "student-3", "student-4", "student-5", "student-6", "student-7", "student-8", "student-10"], absentStudentIds: ["student-9"], timestamp: demoTimestamp("2026-03-24T08:55:00Z") },
    { id: "att-8", date: "2026-03-26", presentStudentIds: ["student-1", "student-3", "student-4", "student-5", "student-6", "student-7", "student-8", "student-9", "student-10"], absentStudentIds: ["student-2"], timestamp: demoTimestamp("2026-03-26T08:55:00Z") },
  ],
  "class-2": [
    { id: "att-9", date: "2026-03-04", presentStudentIds: ["student-11", "student-12", "student-13", "student-14", "student-15"], absentStudentIds: ["student-16"], timestamp: demoTimestamp("2026-03-04T12:55:00Z") },
    { id: "att-10", date: "2026-03-11", presentStudentIds: ["student-11", "student-12", "student-14", "student-15", "student-16"], absentStudentIds: ["student-13"], timestamp: demoTimestamp("2026-03-11T12:55:00Z") },
    { id: "att-11", date: "2026-03-18", presentStudentIds: ["student-11", "student-12", "student-13", "student-15", "student-16"], absentStudentIds: ["student-14"], timestamp: demoTimestamp("2026-03-18T12:55:00Z") },
    { id: "att-12", date: "2026-03-25", presentStudentIds: ["student-12", "student-13", "student-14", "student-15", "student-16"], absentStudentIds: ["student-11"], timestamp: demoTimestamp("2026-03-25T12:55:00Z") },
  ],
};

export const GUEST_DAILY_ROLLUPS = {
  "class-1": [
    { id: "2026-03-03", date: "2026-03-03", positive: 2, negative: 1, objective: 1 },
    { id: "2026-03-05", date: "2026-03-05", positive: 1, negative: 2, objective: 1 },
    { id: "2026-03-10", date: "2026-03-10", positive: 2, negative: 0, objective: 1 },
    { id: "2026-03-12", date: "2026-03-12", positive: 2, negative: 2, objective: 0 },
    { id: "2026-03-17", date: "2026-03-17", positive: 1, negative: 1, objective: 1 },
    { id: "2026-03-19", date: "2026-03-19", positive: 0, negative: 1, objective: 1 },
    { id: "2026-03-24", date: "2026-03-24", positive: 2, negative: 0, objective: 1 },
    { id: "2026-03-26", date: "2026-03-26", positive: 1, negative: 1, objective: 0 },
  ],
  "class-2": [
    { id: "2026-03-04", date: "2026-03-04", positive: 2, negative: 1, objective: 1 },
    { id: "2026-03-11", date: "2026-03-11", positive: 2, negative: 1, objective: 1 },
    { id: "2026-03-18", date: "2026-03-18", positive: 1, negative: 2, objective: 1 },
    { id: "2026-03-25", date: "2026-03-25", positive: 3, negative: 0, objective: 1 },
  ],
};

export const GUEST_DESK_LAYOUTS = {
  "class-1": {
    default: {
      desks: createDeskMap(12),
      seating: {
        desk1: "student-1",
        desk2: "student-2",
        desk3: "student-3",
        desk4: "student-4",
        desk5: "student-5",
        desk6: "student-6",
        desk7: "student-7",
        desk8: "student-8",
        desk9: "student-9",
        desk10: "student-10",
      },
    },
  },
  "class-2": {
    default: {
      desks: createDeskMap(8),
      seating: {
        desk1: "student-11",
        desk2: "student-12",
        desk3: "student-13",
        desk4: "student-14",
        desk5: "student-15",
        desk6: "student-16",
      },
    },
  },
};
